import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter } from 'react-modal-bootstrap';
import './GeneralModal.scss';


class ValidationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: this.props.show,
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      this.state = {
        showModal: this.props.show,
      };
    }
  }

  handleOnNoCTA = () => {
    this.setState({ showModal: false });
    if (this.props.onNo) {
      this.props.onNo();
    }
  }

  handleOnYesCTA = () => {
    this.setState({ showModal: false });
    if (this.props.onYes) {
      this.props.onYes();
    }
  }

  render() {
    return (
      <Modal
        className="topLevelontainer"
        isOpen={this.state.showModal}
        onRequestHide={() => this.setState({ showModal: false })}
      >
        <ModalBody>
          <div dangerouslySetInnerHTML={{ __html: this.props.bodyText }} />
        </ModalBody>
        <ModalFooter>
          <button
            className="btn pinkBtn"
            onClick={this.handleOnNoCTA}
          >
            No
          </button>
          <button
            className="btn greenBtn"
            onClick={this.handleOnYesCTA}
          >
            Yes
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}

ValidationModal.propTypes = {
  bodyText: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onNo: PropTypes.func,
  onYes: PropTypes.func,
};

ValidationModal.defaultProps = {
  onNo: null,
  onYes: null,
};

export default ValidationModal;
